import PassengerAddress from "../../common/types/passenger-address";
import PassengerDispatchSelectOption from "../../common/types/passenger-dispatch-select-option";
import { CargoCompanyDispatchListItem } from "../../../../../common/services/cargo-company/dispatch/list/cargo-company-dispatch-list";
import { PassengerAddParamsPassengerAddress } from "../../../../../common/services/passenger/add/passenger-add-params";

const createAddPassengerRequestAddress = (
  formDataAddress: PassengerAddress,
): PassengerAddParamsPassengerAddress => {
  return {
    lat: formDataAddress.latitude,
    lon: formDataAddress.longitude,
    country: formDataAddress.country.trim(),
    town: formDataAddress.town.trim(),
    street: formDataAddress.street.trim(),
    zipCode: formDataAddress.zipCode.trim(),
    houseNo: formDataAddress.houseNumber.trim(),
    apartment: formDataAddress.apartmentNumber.trim(),
    description: formDataAddress.description.trim() || "",
  };
};

const createAddPassengerRequestAddresses = (
  formDataAddresses: PassengerAddress[],
): PassengerAddParamsPassengerAddress[] => {
  return formDataAddresses.map((address: PassengerAddress) => {
    return createAddPassengerRequestAddress(address);
  });
};

const createAddPassengerRequestDispatchIds = (
  formDataDispatches: PassengerDispatchSelectOption[],
): string[] => {
  return formDataDispatches.map((dispatch) => {
    return dispatch.value.uuid;
  });
};

const createDispatchSelectOption = (
  responseDispatch: CargoCompanyDispatchListItem,
): PassengerDispatchSelectOption => {
  return {
    label: responseDispatch.displayName,
    value: {
      uuid: responseDispatch.uuid,
      displayName: responseDispatch.displayName,
      addressString: responseDispatch.address,
      cargoCompanyId: responseDispatch.cargoCompanyId,
    },
  };
};

const createDispatchSelectOptions = (
  responseDispatches: CargoCompanyDispatchListItem[],
): PassengerDispatchSelectOption[] =>
  responseDispatches.map(createDispatchSelectOption);

const passengerAddFactory = {
  createAddPassengerRequestDispatchIds,
  createDispatchSelectOptions,
  createAddPassengerRequestAddresses,
};

export default passengerAddFactory;
